import { useId } from 'react';
import type { IVtsSampleProductAttribute } from '../../../../Abstracts/ExhibitorPopup/Samples/Samples';
import QuantityField from '../../QuantityField/QuantityField';
import styles from '../SamplesPanel.module.scss?module';

interface SampleRowProps {
  attribute: IVtsSampleProductAttribute;
  /** Name of the sample product size, for the accessible label of the field. */
  sizeName: string;
  quantity: number;
  onQuantityChange: (attributeId: number, quantity: number) => void;
}

const NUMBER_FORMAT = new Intl.NumberFormat('en-GB');

/** One sample flavour with its stock and the shared quantity field capped at the stock. */
export default function SampleRow({
  attribute,
  sizeName,
  quantity,
  onQuantityChange,
}: SampleRowProps) {
  const inputId = useId();
  const stock = Math.max(0, attribute.stock_available);
  const isReserved = stock === 0;

  return (
    <li className={styles.sampleRow}>
      <div className={styles.sampleText}>
        <label htmlFor={inputId} className={styles.sampleFlavour}>
          {attribute.name}
          <span className={styles.visuallyHidden}>, {sizeName}</span>
        </label>
        <span className={styles.sampleStock}>
          {isReserved ? 'reserved' : NUMBER_FORMAT.format(stock) + ' available'}
        </span>
      </div>
      <QuantityField
        id={inputId}
        value={quantity}
        max={stock}
        disabled={isReserved}
        label={attribute.name + ', ' + sizeName}
        onChange={(next) => onQuantityChange(attribute.id, next)}
      />
    </li>
  );
}
